// Compatibility shim (Wave 1 · S2). The generated ml-scribe (v2) OpenAPI types
// now live in `@heidi/schema/ml-scribe`; this re-export keeps the ~2,000 existing
// `@/types/schema` importers (and their `jest.mock` sites) compiling unchanged.
//
// Runtime `export *` — NOT `export type *`: schema.ts emits 604 runtime enums,
// and ~97% of importers use value imports. A type-only re-export would erase
// every enum value. Burned down by the deferred consumer codemod (Wave 1 · S5).
export * from '@heidi/schema/ml-scribe';
